// extracted by mini-css-extract-plugin
module.exports = {"email-modal-body":"styles-module__email-modal-body___2nquG"};